// extracted by mini-css-extract-plugin
export default {"greeting-image":"GreetingImage_greeting-image__RLjVN"};